import styled from 'styled-components';
import { Box } from 'pcln-design-system';
export const ErrorImgWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ErrorComponentstyles__ErrorImgWrapper",
  componentId: "sc-1ha6hd0-0"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1;"]);
export const ErrorTextWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ErrorComponentstyles__ErrorTextWrapper",
  componentId: "sc-1ha6hd0-1"
})(["position:absolute;bottom:20px;left:0;right:0;box-sizing:border-box;z-index:1;span{font-weight:bold;}"]);